import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { loyaltyService } from '@/api/services/loyaltyService'

export function useLoyaltyRecords(p?: Parameters<typeof loyaltyService.list>[0]) {
  return useQuery({ queryKey: ['loyalty', p], queryFn: () => loyaltyService.list(p), staleTime: 60_000 })
}
export function useEligibleRewardTrainers(p?: Parameters<typeof loyaltyService.eligibleTrainers>[0]) {
  return useQuery({ queryKey: ['loyalty', 'eligible', p], queryFn: () => loyaltyService.eligibleTrainers(p), staleTime: 30_000 })
}
export function useProcessReward() {
  const qc = useQueryClient()
  return useMutation({ mutationFn: (d: Record<string, unknown>) => loyaltyService.processReward(d), onSuccess: () => qc.invalidateQueries({ queryKey: ['loyalty'] }) })
}
